import React, { Component } from 'react';
import { divide } from '../../../../../../models/market-map/divider';
import Industrie from '../Industrie';
import './index.css';


class Sector extends Component {

  constructor(props) {
    super(props);
    this.state = {
      industries: [],
      ticker:null,
      industrie:null
    }
    this.divideIndustries = this.divideIndustries.bind(this);
    this.handleMouseHover = this.handleMouseHover.bind(this);
    this.mapIndustries = this.mapIndustries.bind(this);
    this.renderIndustries = this.renderIndustries.bind(this);
    this.setMarketMapRatio = this.setMarketMapRatio.bind(this);
  }

  
  setMarketMapRatio(){
    this.renderIndustries(this.props.sector, this.props.showPrice, this.props.searchResult);
  }

  componentDidMount(){
    this.renderIndustries(this.props.sector, this.props.showPrice, this.props.searchResult);
    window.addEventListener('resize', this.setMarketMapRatio);
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.setMarketMapRatio)
  }
  

  UNSAFE_componentWillReceiveProps(newProps){
    if((newProps.sector.updatedAt !== this.props.sector.updatedAt) || 
    (newProps.showPrice !==this.props.showPrice) || (newProps.searchResult !==this.props.searchResult)){
      this.renderIndustries(newProps.sector, newProps.showPrice, newProps.searchResult)
    }
  }

  divideIndustries(sector){
    const { w,h } = sector.position;
    let _w = w-10;
    let _h = h-20;
    let industries = divide(sector.industries,_w,_h,0,0) //(data array, width, height, left, top);
    return  industries;
  }

  mapIndustries(industries, showPrice, searchResult){
    let res = industries.map((industrie, index)=>{return (<Industrie key={industrie.scale + index + industrie.title} showPrice={showPrice}
      industrie={industrie} onMouseHover={this.handleMouseHover} searchResult={searchResult}/>)})
    return res;
  }

  renderIndustries(sector, showPrice, searchResult){
    let res = this.divideIndustries(sector);
    let industries = this.mapIndustries(res, showPrice, searchResult);
    this.setState({industries});
  }

  handleMouseHover(industrie, ticker){
    this.props.onMouseHover(industrie, ticker)
  }

  render() {
    const { industries } = this.state;
    const { w,h,t,l } = this.props.sector.position;
    //console.log('Sector searchResult --------- ', this.props.searchResult)
    return (
      <div id='sc-market-map-sector-container' 
        style={{width:w, height:h, top:t, left:l}}>
        <div className='sc-market-map-sector-text'>{this.props.sector.title}</div>
        <div className='sc-market-map-industries-wrapper' style={{width:w-10, height:h-20}}>{industries}</div>
      </div>
    );
  }
}


export default Sector;




